/* TX 24/09/2026 (Jono): no nodes inserted, so the Judge Me MutationObserver is not fed; a viewer's pause sticks */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(video) {
    if (video.dataset.txJsReady === '1') return;
    video.dataset.txJsReady = '1';
    /* TX 29/09/2026: src is only attached within 800px of the screen */
    function load() {
      if (!video.getAttribute('src') && video.getAttribute('data-src')) video.src = video.getAttribute('data-src');
    }
    if (REDUCED && REDUCED.matches) {
      load();
      video.removeAttribute('autoplay');
      video.pause();
      video.controls = true;
      return;
    }
    var btn = video.parentNode.querySelector('[data-tx-js-pause]');
    var userPaused = false;
    function play() {
      if (userPaused) return;
      load();
      var p = video.play();
      /* TX 30/09/2026: blocked autoplay (Safari setting, battery saver) falls back to native controls */
      if (p && p.catch) p.catch(function () { video.controls = true; });
    }
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        userPaused = !userPaused;
        btn.setAttribute('aria-pressed', String(userPaused)); btn.setAttribute('aria-label', userPaused ? 'Play video' : 'Pause video');
        if (userPaused) video.pause(); else play();
      });
    }
    if (!('IntersectionObserver' in window)) { play(); return; }
    var near = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { load(); near.disconnect(); }
    }, { rootMargin: '800px 0px' });
    near.observe(video);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play();
        else video.pause();
      });
    }, { rootMargin: '200px 0px' }).observe(video);
  }

  function boot() {
    document.querySelectorAll('[data-tx-js-video]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
